import script from "./UserDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetails.vue?vue&type=script&setup=true&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=be346ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be346ff6"]])

export default __exports__